import { render, staticRenderFns } from "./CurriculumWrite.vue?vue&type=template&id=1194614c&scoped=true&"
import script from "./CurriculumWrite.vue?vue&type=script&lang=ts&"
export * from "./CurriculumWrite.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumWrite.vue?vue&type=style&index=0&id=1194614c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1194614c",
  null
  
)

export default component.exports